<template>
  <div class="border-0 card">
    <div class="border border-left-0 border-right-0 border-top-0 ml-2 py-2">
      <div class="card-title d-flex align-items-center">
        <div class="d-flex align-items-center">
          <img
            :src="require('@/assets/images/payment/payment1.png')"
            class="mr-2"
            height="30"
          />
          <div class="">
            <h6 class="font-weight-semibold mb-0">
              {{ $t("QR Promptpay") }}
            </h6>
            <span class="text-grey-300">
              <i class="fa-solid fa-circle-info" />
              {{ $t("Once payment confirmation is received, the order will be effective immediately.") }}
            </span>
          </div>
        </div>
        <!-- <span class="badge mr-2 step-num">5</span>{{ $t("_newWallet.Pay") }} -->
      </div>
    </div>
    <!-- <div class="card-header bg-light-f6f6f6 border-0 py-2">
        <div class="h3 card-title d-flex align-items-center font-weight-bold">
            <span class="badge  mr-2 step-num">
                5
            </span> {{$t('Pay')}}
        </div>
    </div> -->
    <div class="">
      <div class="border border-left-0 border-right-0 border-top-0 ml-2">
        <div class="row">
          <div class="col-md-12">
            <div class="row mt-2 mb-2">
              <div class="col-md-6">
                {{ $t('_ShippingCredit.Total Payment') }}
              </div>
              <div class="col-md-6 text-right">
                <span class="text-danger">
                  {{ orderData.prompay_info.paid | formatNumber }}
                </span>
              </div>
              <div class="col-md-6">
                {{ $t('_ShippingCredit.Payment Within') }}
              </div>
              <div class="col-md-6 text-right">
                <span>
                  <!-- <button
                    v-if="timeOut"
                    @click="resetTimeLeft()"
                    class="btn btn-outline-primary"
                  >
                    {{ $t("Regenerate") }}
                  </button> -->
                  <span 
                    v-if="timeOut"
                    @click="resetTimeLeft()"
                    class="pointer-cursor"
                  >
                    <span class="text-danger">
                      00.00.00
                    </span>
                    <i class="fas fa-undo " />
                  </span>
                  <span 
                    v-else 
                    class="text-danger"
                  >
                    {{ timeLeft }}
                  </span
                  >
                </span>
              </div>
              <!-- <div class="col-md-6">
              </div>
              <div class="col-md-6 text-right">
                {{ $t('กำหนด')+ ' ' + orderData.prompay_info.expiry_time }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex p-3">
        <div class="rounded-bottom shadow">
          <div class=" text-center">
            <img
              :src="$storeIndex.getImageSrc('payment/title-thai-qr')"
              class=""
            />
          </div>
          <div class=" text-center my-2">
            <img
              :src="$storeIndex.getImageSrc('payment/promptPay2')"
              class=""
              width="155"
            />
          </div>
          <div class=" text-center">
            <img
              :src="orderData.prompay_info.qr_image"
              class=""
              width="270"
            />
          </div>
          <div class="text-center m-3">
            <div class="text-danger">
              {{ orderData.prompay_info.paid | formatNumber }}
            </div>

            <div>
              {{ ('บริษัท Goship จำกัด') }}
            </div>

            <div class="text-grey-300">
              {{ $t('หมายเลขอ้างอิง')+ ' ' + orderData.prompay_info.reference_no}}
            </div>
            <a
              download
              :href="orderData.prompay_info.qr_image"
              class="btn btn-outline-primary font-size-lg m-2"
            >
              {{ $t("Download") }}
            </a>
          </div>
        </div>
        <div class="ml-3">
          <div class="h6 font-weight-bold">
            กรุณาปฏิบัติตามคำแนะนำดังต่อไปนี้:
          </div>
          <ol class="pl-3">
            <li>
              กดที่ปุ่ม “บันทึก QR Code” หรือถ่ายภาพหน้าจอเพื่อรับภาพ QR Code
            </li>
            <li>
              เปิดแอปพลิเคชันธนาคารบนมือถือบนอุปกรณ์ของคุณ (รองรับการชำระเงินผ่านแอป Mobile Banking เท่านั้น)
            </li>
            <li>
              เลือกเมนู “สแกน QR Code” บนแอปเพื่อสแกนหรือแนบภาพ QR Code
            </li>
            <li>
              กรุณาตรวจสอบให้แน่ใจว่าผู้รับคือ “Goship Co., Ltd.”
            </li>
            <li>
              เมื่อชำระเงินสำเร็จ คำสั่งซื้อของคุณจะได้รับการอัปเดตสถานะและมีผลทันที (สามารถตรวจสอบได้จากประวัติ การชำระเงิน)
            </li>
          </ol>
          <div class="border-0 card card-body ml-3">
            <span class="font-weight-bold">หมายเหตุ:</span>
            คุณควรสแกน QR Code เพียงครั้งเดียวต่อรายการและชำระเงินภายใน 10 นาที หากคุณต้องการสแกนหลังจาก QR Code หมดอายุแล้ว กรุณาทำการรีเฟรชเพื่อรับ QR Code ใหม่
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import moment from "moment";
export default {
  props: {
    payAmount: {
      type: [Number, String],
      default: 0
    },
    orderData: {
      type: [Array, Object],
      default: null
    },
  },
  filters: {
    formatNumber: function(value) {
      return numeral(value).format("0,0.00");
    }
  },
  data() {
    return {
      accountName: "Goship Company Ltd.",
      amountToPay: this.payAmount,
      // countDown: 0,
      timeOut: false,
      minute: 9,
      sec: 59,
      hour: 0,
    };
  },
  mounted() {
    // this.countDownTimer();
    this.$nextTick(function() {
      window.setInterval(() => {
        if (this.sec > 0) {
          this.sec--;
        } else if (this.sec == 0 && this.minute > 0) {
          this.sec = 59;
          this.minute--;
        } else {
          // Timer hits 0 do what you want to do here.
          this.timeOut = true;
        }
      }, 1000);
    });
  },
  computed: {
    timeLeft() {
      return String(this.hour).padStart(2, '0') + "." + String(this.minute).padStart(2, '0') + "." + this.zeroPad(this.sec, 2);
    }
  },
  methods: {
    zeroPad(input, length) {
      return (Array(length + 1).join("0") + input).slice(-length);
    },
    resetTimeLeft() {
      this.timeOut = false;
      this.$parent.resetQrCode();
      this.hour = 0;
      this.minute = 9;
      this.sec = 59;
    },
    formatDateTimeWithOffset() {
      const now = new Date(); // เวลาปัจจุบัน
      now.setMinutes(now.getMinutes() + 10); // เพิ่ม 15 นาที
      const hours = String(now.getHours()).padStart(2, '0'); // ชั่วโมง
      const minutes = String(now.getMinutes()).padStart(2, '0'); // นาที

      return `${hours}:${minutes}`;
    },
    formatDatime(dateTime) {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let dateYear = parseInt(moment(dateTime).format('YYYY'));
      let dateMonth = parseInt(moment(dateTime).format('MM') - 1);
      let dateDays = parseInt(moment(dateTime).format('DD'));
      let month = monthNames[dateMonth];
      month = this.$t(month);
      return `${dateDays} ${month} ${dateYear}, ${formatDateTimeWithOffset()}`;
    },
  }
};
</script>

<style scoped>
.bg-light-f6f6f6 {
  background-color: #f6f6f6 !important;
  color: inherit !important;
}
.step-num {
  height: 24px;
  width: 24px;
  font-weight: normal;
  text-align: center;
  padding: 0;
  line-height: 24px;
  background: #333;
  color: #fff;
  border-radius: 100%;
}

ol li {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/account-setting/PayWithQrCode.vue